<template>
    <div>
        <iv-visualisation :title="projectTitle">
            <!-- Tabs and sliders -->
            <template #hotspots>
                <!-- Sliders -->
                <iv-toggle-hotspot position="right" title="Coordinates" style="width: 30vw; z-index: 2;">
                    <div style="width: 100%">
                        <div style=""><iv-toggle-advance :modes=modeNames @toggleswitched="changeToggle" /></div>
                        
                        <label for="rhoSlider" style="border-left: solid 5px rgb(219,209,0);  padding-left: 8px;"> ρ-coordinate:</label>
                        <iv-slider id="rhoSlider" :min="0" :max="4" :init_val="2" :step="0.1" :sliderName="rhoSlider" theme="Lime" @sliderChanged="changeRho" />
                        <label for="phiSlider" style="border-left: solid 5px rgb(182,109,255); padding-left: 8px;">φ-coordinate:</label>
                        <iv-slider id="phiSlider" :min="0" :max="360" :init_val="0" :step="45" :units="º" :sliderName="phiSlider" theme="Lime" :tick_step="60" @sliderChanged="changePhi" />
                        <div v-if="tab">
                            <iv-tickbox :initialMode="false" @checked="checkBox" @unchecked="uncheckBox" />
                            <p style="padding-left: 3vw;">Show Black Label</p>
                        </div>
                    </div>
       
                    
                </iv-toggle-hotspot>
            </template>

            <!-- Instructional pane -->
            <iv-pane position="left">
                <iv-sidebar-content :showPagination="false">
                    <iv-sidebar-section :title="projectTitle">
                        Play around with the sliders to see how polar coordinates work. Switch between looking at the basis vectors and an area element at a specific coordinate. <br><br>

                        How do the basis vectors relate to Cartesian coordinates? <br><br>

                        What is the area of a small area element?
                    </iv-sidebar-section>
                </iv-sidebar-content>
            </iv-pane>

            <!-- Graph -->
            <div class='iv-welcome-message'>
                <div id='graph' style="width: 450px; height: 450px; " />
            </div>
        </iv-visualisation>
    </div>
</template>

<script>
import {name} from '../package.json';
import Plotly from 'plotly.js-dist';
import numeric from 'numeric';
import $ from 'jquery';
import * as math from 'mathjs';

export default {
    name: "App",
    data() {
        return {
            projectName: name,
            projectTitle: "Plane Polar",
            rho: 2,
            phi: 0,
            tab: 0,
            modeNames: ["Basis Vectors", "Area Element"],
            redrawPlot: false,
            switchPlot: false,
            isBlackText: false,
        };
    },
    methods: {
        changeRho(e) {
            this.rho = e;
            this.redrawPlot = true;
            console.log(`Rho: ${this.rho}`);
            console.log(`Tab: ${this.tab}`);
        },
        changePhi(e) {
            this.phi = e;
            this.redrawPlot = true;
            console.log(`Phi: ${this.phi}`);
            console.log(`Tab: ${this.tab}`);
        },
        changeToggle(e) {
            this.tab = e;
            this.redrawPlot = true;
            this.switchPlot = true;
            console.log(`Tab: ${this.tab}`);
        },
        checkBox() {
            this.isBlackText = true;
            this.redrawPlot = true;
        },
        uncheckBox() {
            this.isBlackText = false;
            this.redrawPlot = true;
        },
    },
    mounted() {
        let vm = this;

        // Colour definitions:
        let 
            // magenta = "#FF00FF",
            // blue = "#0000FF",
            // green = "#008000",
            // impBlue = "#003E74",
            black = "rgb(0,0,0)",
            // white = "rgb(255,255,255)",
            cyan = "rgb(0,146,146)", //1
            lilac = "rgb(182,109,255)", //2
            orange = "rgb(219,209,0)"; //3

        // Plot Utilities:
        /**
         * sets camera options in layout.
         * @param {array} point - point of viewpoint.
         */
        // function createView(point) {
        // let norm = Math.sqrt(point[0]*point[0] + (5*point[1])*(5*point[1]) + point[2]*point[2]);
        // let a = 0.5 + point[0]/norm, b = 1 +  5*point[1]/norm, c = 0.5 + point[2]/norm;
        // let camera = {
        //     up: {x: 0, y: 0, z: 1},
        //     eye: {x: -a, y: -b, z: c + 0.5},
        //     center: {x: 0, y: 0, z: -0.2}
        //     }
        // return camera
        // }
        
        /**
         * Creates Axes Object.
         * @param {float} length - length of the half axes.
         */
        // function createAxes(length) {
        //     let axes = [];
        //     let vector = [0, length];
        //     let initialVec;
        //     let vecString = ["x", "y", "z"];
        //     let originString = ["", "", "(0,0,0)"];
        //     for (let i = 0; i < 3; ++i) {
        //         initialVec = [[0, 0], [0, 0], [0, 0]];
        //         initialVec[i] = vector;
        //         axes.push(
        //             {
        //                 type: "scatter3d",
        //                 mode: "lines+text",
        //                 x: initialVec[0],
        //                 y: initialVec[1],
        //                 z: initialVec[2],
        //                 line: {color: "rgb(0,0,0)", width: 4},
        //                 text: [originString[i], vecString[i]],
        //                 textfont: {size: 15},
        //                 textposition: "top"
        //             }
        //         );
        //     }
        //     return axes;
        // }

        // Change of Basis:
        /**
         * changes spherical to cartesian coordinates
         * @param {float} r - r.
         * @param {float} theta - theta.
         * @param {float} phi - phi.
         */
        // function sp2c(r,theta,phi) {
        //     return [
        //         r * Math.sin(theta) * Math.cos(phi),
        //         r * Math.sin(theta) * Math.sin(phi),
        //         r * Math.cos(theta)
        //     ];
        // }

        /**
         * changes cartesian to spherical coordinates
         * @param {float} x - x.
         * @param {float} y - y.
         * @param {float} z - z.
         */
        // function c2sp(x,y,z) {
        //     let r = 0, theta = 0, phi = 0;
        //     if (x*x + y*y + z*z !== 0) {
        //         r = Math.sqrt(x*x + y*y + z*z);
        //         theta = Math.acos(z/r);
        //         phi = Math.atan2(y,x);
        //     }
        //     return [r, theta, phi];
        // }

        /**
         * changes polar to cartesian coordinates
         * @param {float} rho - rho.
         * @param {float} phi - phi.
         */
        function p2c(rho, phi) {
            return [
                rho * Math.cos(phi),
                rho * Math.sin(phi)
            ];
        }
        /**
         * changes cartesian to polar coordinates
         * @param {float} x - x.
         * @param {float} y - y.
         */
        function c2p(x,y) {
            let rho = 0, phi = 0;
            if (x*x + y*y !== 0) {
                rho = Math.sqrt(x*x + y*y);
                phi = Math.atan2(y,x);
            }
            return [rho, phi];
        }


        ///Shape Objects:
        //3D Objects:
        /**
         * Represents a line.
         * @constructor
         * @param {list} points - list of the points in the line.
         */
        // function Line(points) {
        //     this.x = [];
        //     this.y = [];
        //     this.z = [];
        //     for (let i = 0; i  < points.length; ++i) {
        //         this.x.push(points[i][0]);
        //         this.y.push(points[i][1]);
        //         this.z.push(points[i][2]);
        //     }

        //     this.gObject = function(color, width=7, dash="solid") {
        //         let lineObject = {
        //             type: "scatter3d",
        //             mode: "lines",
        //             x: this.x,
        //             y: this.y,
        //             z: this.z,
        //             line: {color: color, width: width, dash:dash}
        //         }
        //         return lineObject;
        //     }

        //     this.arrowHead = function(color, width=7, wingLen=0.1, dash="solid") {
        //         let lastElm = this.x.length - 1;
        //         let [r, theta, phi] = c2sp(this.x[lastElm]-this.x[0], this.y[lastElm]-this.y[0], this.z[lastElm]-this.z[0]);
        //         let offset = [this.x[0], this.y[0], this.z[0]];
        //         let frac = wingLen*r;
        //         let sin45 = Math.sin(Math.PI/4);
        //         let d = r - frac * sin45;
        //         let wingLength = Math.sqrt(Math.pow(frac*sin45,2) + d*d);
        //         let wingAngle = Math.acos(d/wingLength);


        //         let wings_xyz = [
        //             math.add(sp2c(wingLength, theta + wingAngle, phi), offset),
        //             math.add(sp2c(wingLength, theta - wingAngle, phi), offset)
        //         ];

        //         let wings = {
        //             type: "scatter3d",
        //             mode: "lines",
        //             x: [wings_xyz[0][0], this.x[lastElm], wings_xyz[1][0]],
        //             y: [wings_xyz[0][1], this.y[lastElm], wings_xyz[1][1]],
        //             z: [wings_xyz[0][2], this.z[lastElm], wings_xyz[1][2]],
        //             line: {color: color, width: width}
        //         }

        //         return wings;
        //     }
        // }

        /**
         * Represents a point.
         * @constructor
         * @param {array} position - position of the point.
         */
        // function Point(position) {
        //     this.position = position;
        //     this.gObject = function(color, size = 7, symbol="circle") {
        //         let pointObject = {
        //             type: "scatter3d",
        //             mode: "markers",
        //             x: [this.position[0]],
        //             y: [this.position[1]],
        //             z: [this.position[2]],
        //             marker: {"color": color, "size": size, "symbol": symbol}
        //         }
        //         return pointObject;
        //     }
        // }

        /**
         * Represents a sphere.
         * @constructor
         * @param {float} radius - radius of the sphere.
         */
        // function Sphere(radius) {
        //     this.radius = radius;
        //     let meshSize = 20;
        //     let theta = numeric.linspace(0, Math.PI, meshSize);
        //     let phi = numeric.linspace(0, 2*Math.PI, meshSize);
        //     this.x = [], this.y = [], this.z = [];
        //     for(let i = 0; i < meshSize; ++i) {
        //         this.x[i] = [], this.y[i] = [], this.z[i] = [];
        //         for(let j = 0; j < meshSize; ++j) {
        //             this.x[i].push(radius*Math.cos(phi[i])*Math.sin(theta[j]));
        //             this.y[i].push(radius*Math.sin(phi[i])*Math.sin(theta[j]));
        //             this.z[i].push(radius*Math.cos(theta[j]));
        //         }
        //     }
        //     this.gObject = function(color1, color2) {
        //         let sphere = {
        //             type: "surface",
        //             x: this.x,
        //             y: this.y,
        //             z: this.z,
        //             showscale: false,
        //             opacity: 0.6,
        //             colorscale: [[0.0, color1], [1.0, color2]]
        //         }
        //         return sphere;
        //     }
        // }

        /**
         * Represents a cylinder.
         * @constructor
         * @param {float} radius - radius of the circular cross-section.
         * @param {float} height - height of the cylinder.
         */
        // function Cylinder(radius, height){
        //     this.radius = radius;
        //     this.height = height;
        //     let meshSize = radius * 10;
        //     if (meshSize === 0) {meshSize = 2;}
        //     let phi = numeric.linspace(0, 2*Math.PI, meshSize);
        //     this.x = [], this.y = [], this.z = [];
        //     let hValue = numeric.linspace(-height, height, meshSize);

        //     let xTemp = [], yTemp = [], zTemp = [];
        //     for(let i = 0; i < meshSize; ++i) {
        //         xTemp.push(radius*Math.cos(phi[i]));
        //         yTemp.push(radius*Math.sin(phi[i]));
        //     }
        //     for(let i = 0; i < meshSize; ++i) {
        //         this.x.push(xTemp);
        //         this.y.push(yTemp);
        //         this.z.push(numeric.rep([meshSize], hValue[i]));
        //     }

        //     this.gObjectCurve = function(color1, color2) {
        //         let curve = {
        //             type: "surface",
        //             x: this.x,
        //             y: this.y,
        //             z: this.z,
        //             showscale: false,
        //             opacity: 0.7,
        //             colorscale: [[0.0, color1], [1.0, color2]]
        //         }
        //         return curve;
        //     }
        //     this.gObjectTop = function(color) {
        //         let top = {
        //             type: "scatter3d",
        //             mode: "lines",
        //             x: this.x[0],
        //             y: this.y[0],
        //             z: this.z[meshSize - 1],
        //             line: {color: color.slice(0, -1) + ",0.2)", width: 1},
        //             surfaceaxis: 2,
        //             opacity: 0.5
        //         }
        //         return top;
        //     }
        //     this.gObjectBottom = function(color) {
        //         let bottom = {
        //             type: "scatter3d",
        //             mode: "lines",
        //             x: this.x[0],
        //             y: this.y[0],
        //             z: this.z[0],
        //             line: {color: color.slice(0, -1) + ",0.7)", width: 1},
        //             surfaceaxis: 2,
        //             opacity: 0.7
        //         }
        //         return bottom;
        //     }
        // }

        /**
         * Represents a cuboid.
         * @constructor
         * @param {float} x - half length of cuboid in x-direction.
         * @param {float} y - half length of cuboid in y-direction.
         * @param {float} z - half length of cuboid in z-direction.
         */
        // function Cuboid(x, y, z){
        //     this.width = x,
        //     this.length = y,
        //     this.height = z,
        //     this.gObject = function(color) {
        //         let cuboid = {
        //             type: "mesh3d",
        //             x: [-x, -x, x, x, -x, -x, x, x],
        //             y: [-y, y, y, -y, -y, y, y, -y],
        //             z: [-z, -z, -z, -z, z, z, z, z],
        //             i : [0, 0, 3, 4, 4, 4, 4, 4, 5, 6, 6, 7],
        //             j : [2, 3, 4, 3, 6, 7, 1, 5, 2, 2, 7, 3],
        //             k : [1, 2, 0, 7, 5, 6, 0, 1, 1, 5, 2, 2],
        //             opacity: 0.5,
        //             colorscale: [['0', color], ['1', "rgb(255,255,255)"]],
        //             intensity: [0, 0.1, 0.3, 0.5, 0.7, 0.8, 0.9, 1],
        //             showscale: false
        //         }
        //         return cuboid
        //     }
        // }

        //2D Objects:
        /**
         * Represents a circle.
         * @constructor
         * @param {float} radius - radius of the circle.
         */
        function Circle(radius) {
            this.radius = radius;

            this.gObject = function(color=cyan, centre=[0,0]) {
                let phi = numeric.linspace(0, 2*Math.PI, 40);
                let x = [], y = [];
                for (let i=0, n=phi.length; i<n; ++i) {
                    x.push(this.radius*Math.cos(phi[i]) + centre[0]);
                    y.push(this.radius*Math.sin(phi[i]) + centre[1]);
                }
                let circle = {
                    type: "scatter",
                    mode: "lines",
                    x: x,
                    y: y,
                    line: {simplify: false, color: color},
                    fill:'toself',
                    opacity: 0.5
                }
                return circle;
            }
        }
        /**
         * Represents a line.
         * @constructor
         * @param {list} points - list of the points in the line.
         */
        function Line2d(points) {
            this.x = [];
            this.y = [];

            for (let i = 0; i  < points.length; ++i) {
                this.x.push(points[i][0]);
                this.y.push(points[i][1]);
            }

            this.gObject = function(color, width=7, dash="solid") {
                let lineObject = {
                    type: "scatter",
                    mode: "lines",
                    x: this.x,
                    y: this.y,
                    line: {color: color, width: width, dash:dash}
                }
                return lineObject;
            }

            this.arrowHead = function(color, width=7, dash="solid") {
                let lastElm = this.x.length - 1;
                let [rho, phi] = c2p(this.x[lastElm] - this.x[0], this.y[lastElm] - this.y[0]);
                let offset = [this.x[0], this.y[0]];
                let frac = 0.2*rho;
                let sin45 = Math.sin(Math.PI/4);
                let d = rho - frac * sin45;
                let wingLength = Math.sqrt(Math.pow(frac*sin45,2) + d*d);
                let wingAngle = Math.acos(d/wingLength);

                let wings_xyz = [
                    math.add(p2c(wingLength, phi + wingAngle), offset),
                    math.add(p2c(wingLength, phi - wingAngle), offset)
                ];

                let wings = {
                    type: "scatter",
                    mode: "lines",
                    x: [wings_xyz[0][0], this.x[lastElm], wings_xyz[1][0]],
                    y: [wings_xyz[0][1], this.y[lastElm], wings_xyz[1][1]],
                    line: {color: color, width: width, dash: dash}
                }

                return wings;
            }
        }

        //Global Initial Parameters:
        let initialPoint = [2, 0];
        let layout = {
            width: 500, height: 500,
            margin: {l:30, r:30, t:30, b:30},
            hovermode: "closest",
            showlegend: false,
            xaxis: {range: [-5, 5], zeroline: true, title: "x"},
            yaxis: {range: [-5, 5], zeroline: true, title: "y"},
            aspectratio: {x:1, y:1}
        };
        let currentPoint = initialPoint;
        let initialRho = 0, initialPhi = 0; 
            // initialR = 0, initialTheta = 0;
        let isBlackText = false;
        let blackTextType = "lines";

        /**
         * It adds more curvatures to multiply to the curve array.
         * @param {float} arraySize - size of the curve array.
         */
        function curveMore(arraySize) {
            let hello = [], hello2;
            if (arraySize%2 === 0) {
                for (let i = 0, n = Math.round(arraySize/2); i < n; ++i) {
                    hello.push(1 + (i/n/100));
                }
                hello2 = hello.slice();
            } else {
                for (let i = 0, n = Math.round(arraySize/2) - 1; i < n; ++i) {
                    hello.push(1+ (i/n/100));
                }
                hello2 = hello.slice();
                hello.push(1.008);
            }

            return hello.concat(hello2.reverse());
        }

        //Plot
        /**
         * Resets and plots initial area element or basis vectors of plane polar.
         * @param {string} type - basis vectors or area element
         */
        function initPolar(type) {
            Plotly.purge("graph");
            initialRho = Math.sqrt(currentPoint[0]*currentPoint[0] + currentPoint[1]*currentPoint[1]);
            initialPhi = ((Math.atan2(currentPoint[1], currentPoint[0]) + 2*Math.PI) % (2*Math.PI))/Math.PI;
            initialRho = Math.round(initialRho*10)/10;
            initialPhi = Math.round(initialPhi*8)/8;

            // $("#rhoController").val(initialRho);
            // $("#rhoControllerDisplay").text(initialRho);
            // $("#phiController").val(initialPhi);
            // $("#phiControllerDisplayA1").text("(" + initialPhi*8 + "/8)" + $("#phiControllerDisplayA1").attr("data-unit"));
            // $("#phiControllerDisplayA2").text(initialPhi*180 + $("#phiControllerDisplayA2").attr("data-unit"));

            let rho = vm.rho;
            let phi = vm.phi * Math.PI/180;

            if (type == 0){
                Plotly.newPlot("graph", computeBasis(rho, phi), layout);
            } else if (type == 1){
                Plotly.newPlot("graph", computeArea(rho, phi), layout);
            }
            return;
        }
        /**
         * Computes the basis vectors of plane polar.
         * @param {float} rho - rho value.
         * @param {float} phi - phi value.
         */
        function computeBasis(rho, phi) {
            let x = rho*Math.cos(phi);
            let y = rho*Math.sin(phi);
            currentPoint = [Math.round(x*10)/10, Math.round(y*10)/10];

            let meshSize = Math.round(phi/Math.PI*24);
            if (meshSize === 0) {meshSize = 2;}

            let t = numeric.linspace(0, phi, meshSize);
            let xTrace = [], yTrace = [];
            for(let i = 0; i < meshSize; ++i) {
                xTrace[i] = rho*Math.cos(t[i]);
                yTrace[i] = rho*Math.sin(t[i]);
            }
            let circle = new Circle(rho),
                rhoLine = new Line2d([[x, y], [x+Math.cos(phi), y+Math.sin(phi)]]),
                phiLine = new Line2d([[x, y], [x-Math.sin(phi), y+Math.cos(phi)]]);

            let data = [
                rhoLine.gObject(orange, 3),
                rhoLine.arrowHead(orange, 3),
                phiLine.gObject(lilac, 3),
                phiLine.arrowHead(lilac, 3),
                {
                    type: "scatter",
                    mode: "lines",
                    x: [0, x],
                    y: [0, y],
                    line: {color: black, width: 2}
                },
                circle.gObject()
            ];

            return data;
        }
        /**
         * Computes the area element of plane polar.
         * @param {float} rho - rho value.
         * @param {float} phi - phi value.
         */
        function computeArea(rho, phi) {
            let x0 = rho*Math.cos(phi);
            let y0 = rho*Math.sin(phi);
            currentPoint = [Math.round(x0*10)/10, Math.round(y0*10)/10];

            let newPhi = phi + Math.PI/8;

            // let x1 = rho*Math.cos(newPhi);
            // let y1 = rho*Math.sin(newPhi);

            let meshSize0 = Math.round(phi/Math.PI*24);

            let intermediatePhi0 = numeric.linspace(0, phi, meshSize0);
            let xPhi0 = [], yPhi0 = [];
            for(let i = 0; i < meshSize0; ++i) {
                xPhi0[i] = 0.3*rho*Math.cos(intermediatePhi0[i]);
                yPhi0[i] = 0.3*rho*Math.sin(intermediatePhi0[i]);
            }

            let meshSize1 = 9;
            let curved = curveMore(meshSize1);

            let intermediatePhi1 = numeric.linspace(phi, newPhi, meshSize1);
            let xPhi1 = [], yPhi1 = [];
            let xPhi2 = [], yPhi2 = [];
            let xPhi3 = [], yPhi3 = [];
            for(let i = 0; i < meshSize1; ++i) {
                xPhi1[i] = 0.45*rho*Math.cos(intermediatePhi1[i]);
                yPhi1[i] = 0.45*rho*Math.sin(intermediatePhi1[i]);
                xPhi2[i] = curved[i]*rho*Math.cos(intermediatePhi1[i]);
                yPhi2[i] = curved[i]*rho*Math.sin(intermediatePhi1[i]);
                xPhi3[i] = curved[i]*(rho + 1)*Math.cos(intermediatePhi1[i]);
                yPhi3[i] = curved[i]*(rho + 1)*Math.sin(intermediatePhi1[i]);
            }

            let xTrace = xPhi2.concat(xPhi3.reverse());
            xTrace.push(xPhi2[0]);
            let yTrace = yPhi2.concat(yPhi3.reverse());
            yTrace.push(yPhi2[0]);

            let phiText = [];
            for (let i = 0; i < meshSize0; ++i) {
                phiText.push("");
            }
            phiText[Math.round(meshSize0/2)] = "φ";

            let emptyText = [];
            for (let i = 0; i < meshSize1; ++i) {
                emptyText.push("");
            }

            let dphiText = emptyText.slice();
            dphiText[Math.round(meshSize1/2)] = "dφ";

            let rhodphiText = emptyText.slice();
            rhodphiText[Math.round(meshSize1/2)] = "ρ dφ";

            let data = [
                {
                    type: "scatter",
                    mode: "lines+text",
                    x: [x0, x0+0.5*Math.cos(phi), x0+Math.cos(phi)],
                    y: [y0, y0+0.5*Math.sin(phi), y0+Math.sin(phi)],
                    line: {color: orange, width: 3, dash: "solid"},
                    text: ["", "dρ", ""],
                    textfont: {color:orange, size:16}
                },
                {
                    type: "scatter",
                    mode: "lines+text",
                    x: xPhi2,
                    y: yPhi2,
                    line: {color: lilac, width: 3, dash: "solid"},
                    text: rhodphiText,
                    textfont: {color:lilac, size:16}
                },
                {
                    type: "scatter",
                    mode: blackTextType,
                    x: [0, 3*x0/5, x0],
                    y: [0, 3*y0/5, y0],
                    line: {color: "rgb(0,0,0)", width: 2},
                    text: ["", "ρ", ""],
                    textfont: {color:black, size:15}
                },
                {
                    type: "scatter",
                    mode: "lines",
                    x: xTrace,
                    y: yTrace,
                    line: {simplify: false, color: cyan},
                    fill:'tonexty',
                }
            ];

            return data;
        }

        /** updates the plot according to the slider controls. */
        function updatePlot() {
            console.log("updatePlot called");
            let data = [];
            // NB: updates according to the active tab
            let href = vm.tab; // finds out which tab is active

            let rho = vm.rho;
            let phi = vm.phi * Math.PI / 180;

            if (href == 0) {
                data = computeBasis(rho, phi);
            } else if (href == 1) {
                data = computeArea(rho, phi);
            }

            Plotly.animate(
                'graph',
                {data: data},
                {
                    fromcurrent: true,
                    transition: {duration: 0,},
                    frame: {duration: 0, redraw: false,},
                    mode: "afterall"
                }
            );
        }

        function main() {
            console.log("main called");
            /*Jquery*/ //NB: Put Jquery stuff in the main not in HTML
            $("input[type=range]").each(function () {
                let displayEl;
                /*Allows for live update for display values*/
                $(this).on('input', function(){
                    //Displays: (FLT Value) + (Corresponding Unit(if defined))
                    $("#"+$(this).attr("id") + "Display").text( $(this).val() + $("#"+$(this).attr("id") + "Display").attr("data-unit") );

                    //To display angle in degree
                    $("#"+$(this).attr("id") + "DisplayA2").text( parseFloat($(this).val())*180 + $("#" + $(this).attr("id") + "DisplayA2").attr("data-unit") );

                    //To display the angle in radian in terms of fraction multiple of pi
                    if (parseFloat($(this).val())*8 % 8 === 0.0) {
                        displayEl = $(this).val();
                    } else if (parseFloat($(this).val())*8 % 4 === 0.0) {
                        displayEl = "(" + $(this).val()*2 + "/2)";
                    } else if (parseFloat($(this).val())*8 % 2 === 0.0) {
                        displayEl = "(" + $(this).val()*4 + "/4)";
                    } else {
                        displayEl = "(" + $(this).val()*8 + "/8)";
                    }
                    $("#"+$(this).attr("id") + "DisplayA1").text( displayEl + $("#"+$(this).attr("id") + "DisplayA1").attr("data-unit"));

                    //NB: Display values are restricted by their definition in the HTML to always display nice number.

                    updatePlot(); //Updating the plot is linked with display (Just My preference)
                });

            });

            /*Checkbox*/
            $("input[type=checkbox]").each(function () {
                $(this).on("change", function() {
                    isBlackText = !isBlackText;
                    if (isBlackText) {
                        blackTextType = "lines+text";
                    } else {
                        blackTextType = "lines";
                    }
                    initPolar(vm.tab); // re-initialise with/out the black label

                });
            });

            /*Tabs*/
            $(function() {
                $('ul.tab-nav li a.button').click(function() {
                    // let href = $(this).attr('href');
                    // $('li a.active.button', $(this).parent().parent()).removeClass('active');
                    // $(this).addClass('active');
                    // $('.tab-pane.active', $(href).parent()).removeClass('active');
                    // $(href).addClass('active');

                    initPolar(vm.tab); //re-initialise when tab is changed
                    return false;
                });
            });

            //The First Initialisation - I use 's' rather than 'z' :p
            initPolar(vm.tab);
        }

        function animate() {
            requestAnimationFrame(animate);

            if (vm.redrawPlot) {
                if (vm.isBlackText) {
                    blackTextType = "lines+text";
                } else {
                    blackTextType = "lines";
                }

                if (vm.switchPlot) {
                    initPolar(vm.tab);
                    vm.switchPlot = false;
                }
                updatePlot();
                vm.redrawPlot = false;
            }
        }

        animate();

        main();
    }
}
</script>

<style>
.iv-welcome-message {
    display:flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    margin-left: auto;
}
</style>